/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the comparison processing
 * @export
 */
export const ComparisonStatus = {
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type ComparisonStatus = typeof ComparisonStatus[keyof typeof ComparisonStatus];


export function instanceOfComparisonStatus(value: any): boolean {
    for (const key in ComparisonStatus) {
        if (Object.prototype.hasOwnProperty.call(ComparisonStatus, key)) {
            if (ComparisonStatus[key as keyof typeof ComparisonStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComparisonStatusFromJSON(json: any): ComparisonStatus {
    return ComparisonStatusFromJSONTyped(json, false);
}

export function ComparisonStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparisonStatus {
    return json as ComparisonStatus;
}

export function ComparisonStatusToJSON(value?: ComparisonStatus | null): any {
    return value as any;
}

export function ComparisonStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ComparisonStatus {
    return value as ComparisonStatus;
}

